import {
  CloseFullscreen,
  CloseFullscreenRounded,
  History,
} from "@mui/icons-material";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  IconButton,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useRefresh } from "react-admin";
import sendRequest from "../dataProvider/sendRequest";
import useNotify from "../unit/useNotify";
import CustomButtonCancel from "./CustomButtonCancel";
import CustomTable from "./CustomTable";
import CustomTableContainer from "./CustomTableContainer";
import formatDate from "./formatDate";
import CustomPaper from "./CustomPaper";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import { set } from "lodash";
const CustomProductHistoryIcon = ({ ...props }) => {
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);
  const { successNotify, errorNotify } = useNotify();
  const [historyData, setHistoryData] = useState(null);
  const [historyDetailData, setHistoryDetailData] = useState(null);
  const [reqLogId, setReqLogId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [dailogTitle, setDialogTitle] = useState("Product History");

  const formatProductHistoryAction = (actionName: string) => {
    if (actionName == "product-status") return "Product Status";
    if (actionName == "edit") return "Product Edit";
    if (actionName == "create") return "Product Create";
    if (actionName == "set product status = 1") return "Product Status Active";
    if (actionName == "set product status = 0")
      return "Product Status Deactive";

    return actionName;
  };
  const formatProductHistoryValue = (actionName: string, value: any) => {
    if (actionName == "Product Status") {
      if (value == 1) return "Active";
      if (value == 0) return "Deactive";
    }

    return value;
  };
  const handleCheckProductHistory = (logId: any) => {
    const reqUrl = "products/actions/history";
    sendRequest(reqUrl, {
      id: props?.id,
      data: {
        logId: logId,
      },
    }).then((response) => {
      setHistoryData(response?.data);
      // setDialogTitle(`Product History #${props?.id} ${props?.productName}`);
      setDialogTitle(`Product History - ${props?.productName}`);

      // console.log("historyData=========>", historyData);
    });
  };

  const handleCheckProductHistoryDetail = (
    logId: any,
    logDate,
    isDetail: any
  ) => {
    setReqLogId(logId);
    const reqUrl = "products/actions/history";
    sendRequest(reqUrl, {
      id: props?.id,
      data: {
        logId: logId,
        detail: isDetail,
      },
    }).then((response) => {
      setHistoryDetailData(response?.data);
      setDialogTitle(
        `Product History - ${props?.productName} - Log #${logId} Detail (${logDate})`
      );
      // console.log("historyDetailData=========>", historyDetailData);
    });
  };

  return (
    <>
      <Tooltip
        title={props?.label || `View Product History #${props?.id}`}
        placement="left"
        arrow
      >
        <IconButton
          size="small"
          onClick={() => {
            handleCheckProductHistory(0);
            setOpen(true);
          }}
          sx={{ marginLeft: "5px", p: 1 }}
        >
          <History
            fontSize="small"
            sx={{ color: "#1976d2", fontSize: "22px" }}
          />
        </IconButton>
      </Tooltip>
      <Dialog
        fullWidth={true}
        maxWidth="lg"
        open={open}
        // onClose={() => setOpen(false)}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            borderBottom: "1px solid #e5e5e5",
            color: "#465384",
            textTransform: "uppercase",
          }}
        >
          {dailogTitle}
          {/* Close */}
          <IconButton
            aria-label="close"
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mt: "20px", mb: "20px" }}>
            {loading && "Loading product history..."}
            {reqLogId == 0 && historyData && (
              <>
                <CustomTableContainer
                  component={CustomPaper}
                  sx={{
                    height: "650px",
                    overflow: "auto",
                    minHeight: 200,
                  }}
                >
                  <CustomTable
                    stickyHeader
                    id="table-customer-summary-email-list"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell className="hm-table-header">Log #</TableCell>
                        <TableCell
                          sx={{ minWidth: "120px" }}
                          className="hm-table-header"
                        >
                          Action
                        </TableCell>

                        <TableCell
                          sx={{ minWidth: "120px" }}
                          className="hm-table-header"
                        >
                          Change Date
                        </TableCell>
                        <TableCell
                          sx={{ minWidth: "120px" }}
                          className="hm-table-header"
                        >
                          Updated By
                        </TableCell>
                        <TableCell className="hm-table-header">
                          Detail
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {historyData == undefined ||
                      historyData?.length == 0 ||
                      historyData == null ? (
                        <TableRow>
                          <TableCell colSpan={8}>No record. </TableCell>
                        </TableRow>
                      ) : (
                        historyData?.map((item: any) => (
                          <TableRow key={item.id + " " + item.dtInsert}>
                            <TableCell>{item?.id}</TableCell>
                            <TableCell>
                              {formatProductHistoryAction(item?.sAction)}
                            </TableCell>
                            <TableCell>
                              {/* {formatDate(item?.created_at)} */}
                              {item?.created_at}
                            </TableCell>
                            <TableCell>
                              {item?.name ? (
                                <>{item?.name}</>
                              ) : (
                                <>Banker#{item?.iBankerId}</>
                              )}
                            </TableCell>
                            <TableCell>
                              {item?.isDetail > 0 && (
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    handleCheckProductHistoryDetail(
                                      item.id,
                                      item.created_at,
                                      item?.isDetail
                                    )
                                  }
                                  sx={{ p: 0 }}
                                >
                                  <History
                                    fontSize="small"
                                    sx={{ color: "#1976d2", fontSize: "22px" }}
                                  />
                                </IconButton>
                              )}
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </CustomTable>
                </CustomTableContainer>
              </>
            )}
            {/* show Detail History */}
            {reqLogId > 0 && historyDetailData && (
              <>
                <CustomTableContainer component={CustomPaper}>
                  <CustomTable
                    stickyHeader
                    id="table-customer-summary-email-list"
                    sx={{
                      maxHeight: "650px",
                      overflow: "auto",
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell className="hm-table-header">Id #</TableCell>
                        <TableCell
                          sx={{ minWidth: "120px" }}
                          className="hm-table-header"
                        >
                          Name
                        </TableCell>
                        <TableCell
                          sx={{ minWidth: "120px" }}
                          className="hm-table-header"
                        >
                          New Value
                        </TableCell>
                        <TableCell className="hm-table-header">
                          Old Value
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {historyDetailData == undefined ||
                      historyDetailData?.length == 0 ||
                      historyDetailData == null ? (
                        <TableRow>
                          <TableCell colSpan={8}>No record. </TableCell>
                        </TableRow>
                      ) : (
                        historyDetailData?.map((item: any) => (
                          <TableRow key={item.id + " " + item.dtInsert}>
                            <TableCell>{item?.id}</TableCell>
                            <TableCell>{item?.sName}</TableCell>
                            <TableCell
                              sx={{
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                                overflowWrap: "anywhere",
                              }}
                            >
                              {formatProductHistoryValue(
                                item?.sName,
                                item?.sNewValue
                              )}
                            </TableCell>
                            <TableCell
                              sx={{
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                                overflowWrap: "anywhere",
                              }}
                            >
                              {formatProductHistoryValue(
                                item?.sName,
                                item?.sOldValue
                              )}
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </CustomTable>
                </CustomTableContainer>
              </>
            )}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          {/* <CustomButtonCancel onClick={() => setOpen(false)} label="Cancel" /> */}
          {reqLogId > 0 && historyDetailData && (
            <CustomButtonCancel
              onClick={() => {
                setReqLogId(0);
                setHistoryDetailData(null);
                setDialogTitle(`Product History - ${props?.productName}`);
              }}
              label="Back"
            />
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CustomProductHistoryIcon;
